import './Help.scss';
import { gameActions } from "../Game/gameSlice";
import store from "../store";
import { DefaultEnums } from "../Enums/GameEnums"

function Help() {

    function handleClose() {
        store.dispatch(gameActions.hideHelp())
    }

    return (
        <div className="help center">
            <div className="close" onClick={handleClose}>x</div>
            <div className="text-heading button-text">Help</div>
                        <div className='help-content'>
                            <p>Welcome to Blackjack RPG</p>
                            <p>In this game you are trying to defeat monsters and get the crown with the power of Blackjack</p>
                            <p>If you win a game of Blackjack you do damage to monster, if you loose it, the monster deals damage to you</p>                            
                            <p>Ties are counted as player victory</p>
                            <p>Damage is based on bet amount plus attacker attack modifier</p>
                            <p>Defense reduces the amoutn of damage taken, but is countered by piercing</p>
                            <p>1 point of piercing pierces through {DefaultEnums.DEFAULT_PENETRATION_MODIFIER} points of defense</p>
                            <p>Healing is allowed in betting stage and heals for {DefaultEnums.HEAL_AMOUNT} % of hp</p>
                            <p>Upon death you reset your level and stage progression, but keep your stats</p>
                            <p>Good luck and have fun </p>
                        </div>
                        <div className="button-text center-text" onClick={handleClose}>Ok</div>
                    </div>
                );
            }

export default Help;
